<template>
  <v-card flat class="white pb-2 mb-1 pl-2 pa-2">
    <template v-if="isTremendous">
      <template v-if="!loading">
        <TremendousOrderItem :order="order" />
      </template>
      <div v-else class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </template>
    <template v-else-if="selectedBot.type == 'dtac-gaming'">
      <template v-if="!loading">
        <DtacGamingOrderItem :order="order" />
      </template>
      <div v-else class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </template>
    <template v-else>
      <v-layout wrap>
        <v-flex xs6 sm7 class="pl-3 pr-3 pt-2 pb-2 font-weight-bold">
          {{ $t('Order No.') }} {{ order.id }}
        </v-flex>

        <v-flex xs6 sm5 class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
          <label> {{ DateFormat(order.timestamp) }}</label>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="pl-3 pr-3 pt-2 pb-2">
          <multiselect
            v-model="status"
            :options="orderStatusOptions"
            label="label"
            :allow-empty="false"
            :searchable="false"
            select-label
            selected-label
            deselect-label
            track-by="label"
            @select="onSelectOrderStatus"
          ></multiselect>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="['shipped', 'canceled'].includes(order.status) || order.trackingno"
        class="pl-3 pr-3 pt-2 pb-2"
      >
        <v-flex>
          <template
            v-if="
              order.status == 'shipped' &&
              !$store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)
            "
          >
            <v-divider />
            <div class="form-control pt-2">
              <input
                v-model="order.trackingno"
                type="text"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="20"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
                @click="updateOrder(order, true)"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template
            v-else-if="
              order.status == 'canceled' &&
              !$store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)
            "
          >
            <v-divider />
            <div class="form-control pt-2">
              <input
                v-model="order.reason"
                type="text"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="updateOrder(order)"
              >
                <em class="far fa-save" />
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="updateOrder(order, true)"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else>
            <span class="grey--text">{{ $t('Tracking') }}: </span>
            {{ order.trackingno }}
          </template>
        </v-flex>
      </v-layout>
      <v-btn flat small class="ma-0" style="width: 100%" @click="showDetail = !showDetail">
        <em v-if="showDetail" class="fa fa-sort-asc primary-color" aria-hidden="true" />
        <em v-else class="fa fa-sort-desc primary-color" aria-hidden="true" />
      </v-btn>
      <v-layout v-show="showDetail" wrap>
        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <edit-address
            v-if="!loading"
            v-model="order.nameaddress"
            :has-copy="true"
            :show-edit="!$store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)"
            @edited="updateOrder(order)"
          ></edit-address>
          <div v-else class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </v-flex>
        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <h4 class="title">{{ $t('Products') }}</h4>
        </v-flex>
        <template v-if="!loading">
          <template v-for="(product, i) in order.productdetail">
            <v-layout :key="`product_${i}`" wrap>
              <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
                <div style="display: flex">
                  <img
                    :src="product.photourl"
                    aspect-ratio="1"
                    alt
                    class="grey lighten-2"
                    style="width: 30px; height: 30px"
                  />
                  <label class="ml-2 primary-color">
                    {{ product.name }}
                    <span style="color: #000"> ({{ product.option }})</span></label
                  >
                  <label class="ml-2" style="color: #000">x{{ product.quantity }}</label>
                </div>
              </v-flex>
              <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2"> ฿{{ product.price | decimalFormat }}</label>
              </v-flex>
            </v-layout>
          </template>
        </template>
        <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
          <label class="ml-2"> {{ $t('Subtotal') }}</label>
        </v-flex>
        <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
          <label class="ml-2">
            ฿{{ (order.total - (order.shippingcharge ? order.shippingcharge : 0)) | decimalFormat }}
          </label>
        </v-flex>
        <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
          <label class="ml-2"> {{ $t('Shipping fee') }}</label>
        </v-flex>
        <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
          <label class="ml-2"> ฿{{ order.shippingcharge | decimalFormat }}</label>
        </v-flex>
        <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
          <label class="ml-2"> {{ $t('Total') }}</label>
        </v-flex>
        <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
          <label class="ml-2"> ฿{{ JSON.parse(order.amount) | decimalFormat }}</label>
        </v-flex>
        <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
          <img
            v-if="order.shippingtype == 'normal'"
            src="/static/img/assets/payment/normal_charge_logo.png"
            alt
            class="responsive-img"
            style="max-height: 50px"
          />
          <img
            v-else-if="order.shippingtype == 'ems'"
            src="/static/img/assets/payment/ems_charge_logo.png"
            alt
            class="responsive-img"
            style="max-height: 50px"
          />
          <img
            v-else-if="order.shippingtype == 'kerry'"
            src="/static/img/assets/payment/kerry_charge_logo.png"
            alt
            class="responsive-img"
            style="max-height: 50px"
          />
          <template v-else>
            <img
              :src="'/static/img/assets/payment/' + order.shippingtype + '_logo.png'"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <div v-if="order.shippingtype == 'cod_charge'">
              {{ $t('cod_charge') }}
            </div>
          </template>
        </v-flex>
        <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2" style="align-self: center">
          <label class="ml-2"> {{ $t(order.shippingtype) }}</label>
        </v-flex>
      </v-layout>
    </template>
  </v-card>
</template>

<script>
import TremendousOrderItem from './TremendousOrderItem.vue'
import DtacGamingOrderItem from './DtacGamingOrderItem.vue'
import EditAddress from '../template/ecommerce/EditAddress.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import { ACOMMERCE_STATUS_OPTIONS, STATUS_OPTIONS } from '@/constants/acommerce.js'
import { PAGE } from '@/constants/page.js'
export default {
  components: {
    EditAddress,
    multiselect,
    TremendousOrderItem,
    DtacGamingOrderItem
  },
  props: {
    order: {},
    loading: {}
  },
  data() {
    return {
      showDetail: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    orderStatusOptions() {
      if (this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)) {
        return ACOMMERCE_STATUS_OPTIONS.map((status) => ({
          label: this.$t(`ACOMMERCE_${status}`),
          value: status
        }))
      } else {
        return STATUS_OPTIONS.map((status) => ({
          ...status,
          label: this.$t(status.label)
        }))
      }
    },
    status: {
      get() {
        const status = this.orderStatusOptions.find((status) => status.value == this.order.status)
        return status || null
      },
      set(value) {}
    },
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    updateOrder(order, isSend = false) {
      this.$emit('updateOrder', { order, isSend })
    },
    onSelectOrderStatus(status) {
      let order = this.order
      order.status = status.value
      this.updateOrder(order)
      this.$emit('onChangeStatus')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatOrderSummaryItem.vue